export const ADMIN = 'Admin';
export const TRAINER = 'Trainer';
export const MANAGER = 'Manager';
